import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClearinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.414 8l2-2L10 4.586l-2 2-2-2L4.586 6l2 2-2 2L6 11.414l2-2 2 2L11.414 10l-2-2zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgClearinline;
